<template>
  <div>
    <div class="top">
      <img src="~common/image/rank-three.png" alt="" class="bg">
      <div>
        <div class="avatar" :class="mapNum(i)" v-for="(item,i) in top" :key="item.user_id">
          <div><img :src="item.icon" alt=""></div>
        </div>
      </div>
      <div class="info" :class="mapNum(i)" v-for="(item,i) in top" :key="item.user_id">
        <div class="num">{{i+1}}</div>
        <div class="name">{{item.name}}</div>
        <div class="time">{{item.sum_total}}分钟</div>
      </div>
    </div>
    <div class="list">
      <div>
        <div class="item border-bottom" v-for="(item, index) in list" :key="item.user_id">
          <div class="num">{{index+4}}</div>
          <div class="avatar"><img :src="item.icon" alt=""></div>
          <div class="name">{{item.name}}</div>
          <div class="time">{{item.sum_total}}分钟</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRankList} from '@/api/rank'
export default {
  data() {
    return {
      data: []
    }
  },
  created() {
    getRankList(2).then(data => {
      if (data) {
        this.data = data
      }
    })
  },
  computed: {
    top() {
      return this.data.slice(0, 3)
    },
    list() {
      return this.data.slice(3)
    }
  },
  methods: {
    mapNum(i) {
      return ['one', 'two', 'three'][i]
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~common/stylus/variable"
.top{
  padding-top percentage(102 / 750)
  position relative
  .bg{
    width percentage(616 / 750)
    margin 0 auto 0
    display block
  }
  .avatar{
    width percentage(122 / 750)
    position absolute
    >div{
      width 100%
      padding-bottom 100%
      background-image url('~common/image/rank-avatar.png')
      background-size 100% 100%
      position relative
      img{
        position absolute
        width 100%
        height 100%
        left 0
        top 0
        border-radius 50%
        overflow hidden
      }
    }
    &.one{
      top 0
      left 50%
      transform translateX(-50%)
    }
    &.two{
      left percentage(110 / 750)
      top percentage(190/ 750)
      img{
        transform-origin 50% 50%
        transform rotate(-10deg)
      }
    }
    &.three{
      right percentage(110 / 750)
      top percentage(190/ 750)
      img{
        transform-origin 50% 50%
        transform rotate(10deg)
      }
    }
  }
  .info{
    position absolute
    text-align center
    color #fff
    width percentage(180 / 750)
    padding 0 size(10)
    .num{
      font-size size(68)
      line-height size(88)
      // font-weight 800
    }
    .name{
      txt-overflow(1)
      font-size size(32)
      line-height size(46)
    }
    .time{
      font-size size(28)
      margin-top:size(10);
    }
    &.one{
      top percentage(256 / 750)
      left 50%
      transform translateX(-50%)
    }
    &.two,&.three{
      .name{
        font-size size(30)
      }
      .num{
        font-size size(60)
        line-height size(60)
      }
    }
    &.two{
      top percentage(450 / 750)
      left 13%
      transform-origin 50% 50%
      transform rotate(-10deg)
    }
    &.three{
      top percentage(450 / 750)
      right 14%
      transform-origin 50% 50%
      transform rotate(10deg)
    }
  }
}
.list{
  padding: 0 size(40)
  >div{
    background #fff
    border-radius size(18)
    padding  0 size(38)
    .item{
      height size(110)
      display flex
      align-items center
      &:before{
        background #f4f4f4
      }
      .num{
        width size(64)
        color #bcc4ce
        font-size size(44)
      }
      .avatar{
        width size(62)
        height size(62)
        border-radius 50%
        background-image url('~common/image/rank-avatar.png')
        background-size 100% 100%
        overflow hidden
        img{
          width 100%
          height 100%
        }
      }
      .name{
        flex 1
        padding-left size(40)
        padding-right size(24)
        txt-overflow(1)
        color #717b85
      }
      .time{
        font-size size(34)
        color #95a0ae
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/rank/people.vue